<div class="filter">
	@if(singleSector) {
	<div class="sector">
		<div class="sector-label">
			<span>{{ sectorLabel }}</span>
		</div>
		<div class="sector-radios">
			@for(sector of sectors; track sector) {
			<div class="radio-with-label">
				<input
					[id]="`${sector}-radio`"
					type="radio"
					[value]="sector"
					[(ngModel)]="currentSector"
					(change)="changeSector(sector)"
				/>
				<label [for]="`${sector}-radio`">{{ sector }}</label>
			</div>
			}
		</div>
	</div>
	}
	<div
		class="content"
		[ngClass]="{
			'no-search-results': !isSearchResultsScreen,
		}"
	>
		<div class="controls">
			<div class="left">
				@if(showLocationSelector){
				<simple-selector
					[enableFilter]="true"
					label="{{ Loc(LocalizedTextIds.Location) }}"
					[menuOptions]="locationOptions"
					(select)="updateLocationFilter($event)"
					(afterSelect)="trackForAnalytics('location', $event)"
				>
				</simple-selector>
				}@if(!singleSector) {
				<sector-and-child-dropdown
					[hidden]="hidePrimarySectorSelector"
					(optionsSelected)="updateSectorFilter($event)"
					label="{{ Loc(LocalizedTextIds.Sector) }}"
				>
				</sector-and-child-dropdown>
				}

				<sector-and-child-dropdown
					[hidden]="hideSecondarySelector"
					[isPrimary]="false"
					(optionsSelected)="updateSecondarySectorFilter($event)"
					label="{{ Loc(LocalizedTextIds.SecondarySector) }}"
				>
				</sector-and-child-dropdown>

				<simple-selector
					[enableFilter]="true"
					[hidden]="hideIndicationSelector"
					label="{{ Loc(LocalizedTextIds.Indication) }}"
					[menuOptions]="indicationOptions"
					(select)="updateIndicationFilter($event)"
					(afterSelect)="trackForAnalytics('indication', $event)"
				>
				</simple-selector>

				<!-- Companies have indications that are called focus areas in universal.
				 but assets have focus areas in all environments (which correspond to the subsector
				 on a company). -->

				<sector-and-child-dropdown
					[hidden]="isCompanyMode"
					[selectableSectors]="false"
					(optionsSelected)="updateFocusAreaFilter($event)"
					label="{{ Loc(LocalizedTextIds.FocusArea) }}"
					otherField="focusArea"
					[singleSector]="currentSector"
				>
				</sector-and-child-dropdown>

				<simple-selector
					[hidden]="isCompanyMode"
					[enableFilter]="true"
					label="{{ Loc(LocalizedTextIds.TherapeuticArea) }}"
					[menuOptions]="therapeuticAreaOptions"
					(select)="updateTherapeuticAreaFilter($event)"
					(afterSelect)="trackForAnalytics('therapeuticArea', $event)"
				>
				</simple-selector>

				<sector-and-child-dropdown
					[hidden]="isCompanyMode"
					(optionsSelected)="updateDevelopmentStageFilter($event)"
					label="{{ Loc(LocalizedTextIds.DevelopmentStage) }}"
					otherField="developmentStage"
					[selectableSectors]="false"
					[singleSector]="currentSector"
				>
				</sector-and-child-dropdown>
				@if(showClearFilterAction){
				<div class="cf_filter-content-clear" (click)="clearFilter()">
					<span>{{ Loc(LocalizedTextIds.FilterClearAll) }}</span>
				</div>
				}
			</div>
			<div class="right">
				@if(isCompanyMode){ @if(isFollowEnabled && isInternalView){
				<label for="followedCompaniesOnly">
					{{
						Loc(
							LocalizedTextIds.FilterItemsImFollowing,
							modePluralName
						)
					}}
					<input
						type="checkbox"
						class="checkbox"
						id="followedCompaniesOnly"
						name="followedCompaniesOnly"
						[(ngModel)]="followedCompaniesOnly"
					/> </label
				>} @if(useStatusDropdown &&
				featureSwitches.enableShowLocationStatus){
				<status-selector
					[menuOptions]="statusOptions"
					(select)="updateStatusFilter()"
					(afterSelect)="trackForAnalytics('status', $event)"
					label="{{ Loc(LocalizedTextIds.Status) }}"
				>
				</status-selector>
				} @if(!useStatusDropdown &&
				featureSwitches.enableShowLocationStatus){ @for(menuOption of
				optionsForSingleRow; track menuOption.id){

				<label [for]="menuOption.id">
					{{ menuOption.label }}
					<input
						type="checkbox"
						class="checkbox"
						[attr.id]="menuOption.id"
						[attr.name]="menuOption.id"
						[(ngModel)]="menuOption.value"
						(ngModelChange)="updateStatusFilter()"
					/>
				</label>
				} } } @if(isInternalView && !isCompanyMode) {
				<label for="followedAssetsOnly">
					{{
						Loc(
							LocalizedTextIds.FilterItemsImFollowing,
							modePluralName
						)
					}}
					<input
						type="checkbox"
						class="checkbox"
						id="followedAssetsOnly"
						name="followedAssetsOnly"
						[(ngModel)]="followedAssetsOnly"
					/> </label
				>}
			</div>
		</div>
	</div>
	@if(hasAdditionalFilterConstraints){
	<div class="filter-additional-constraints">
		<div
			class="filter-additional-constraints-item"
			*ngFor="let item of activeAdditionalFilterConstraints"
		>
			<div class="filter-additional-constraints-item-title">
				{{ item.displayString() }}
			</div>
			<div class="filter-additional-constraints-item-divider"></div>
			<div
				class="filter-additional-constraints-item-X"
				(click)="clearAdditionalFilterConstraint(item)"
			>
				X
			</div>
		</div>
	</div>
	}
</div>
